import { render, staticRenderFns } from "./ConfiguracoesMensagemOptout.vue?vue&type=template&id=3b76df10"
import script from "./ConfiguracoesMensagemOptout.vue?vue&type=script&lang=js"
export * from "./ConfiguracoesMensagemOptout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports